<template lang="pug">
  .auth
    .auth__wrapper
      header.auth__header.auth-header.auth-header--fixed
        .auth-header__wrapper
          a(href="/").auth-header__link
            i.i-header-logo.auth-header__logo
            span.auth-header__text Profeed
          .auth-header__lang
            lang-switcher-dropdown
      main.auth__content
        .auth__login
          .auth__login-wrapper
            h1.auth__login-title Profeed
            p.auth__login-desc {{ 'auth.title' | translate }}
            form.form.auth__form(
              @submit.prevent="login")
              .form__group
                input.form__input(
                  v-model="username"
                  required
                  type="text"
                  autocomplete="username"
                  :placeholder="$t('auth.login')")
              .form__group.form__group--space-lg
                input.form__input(
                  v-model="password"
                  required
                  type="password"
                  autocomplete="current-password"
                  :placeholder="$t('auth.password')")
              .form__group
                v-btn(
                  :loading="loading") {{ 'auth.signin' | translate }}
        //- .auth__service
        //-   h2.auth__service-title {{ 'auth.description' | translate }}
        //-   p.auth__service-desc {{ 'auth.description_2' | translate }}
        //-   v-btn(
        //-     @click="goAway") {{ 'auth.control_farm' | translate }}
      footer.auth__footer
        p.auth__footer-copy &copy; Profeed 2025
</template>

<script>
import LangSwitcherDropdown from '@/components/layouts/app-header/LangSwitcherDropdown'

export default {
  name: 'Auth',

  components: {
    LangSwitcherDropdown
  },

  data: () => ({
    username: '',
    password: '',
    loading: false
  }),

  methods: {
    async login () {
      const payload = {
        email: this.username,
        password: this.password
      }
      this.loading = true
      const { errors } = await this.$store.dispatch('account/login', payload)
      if (!errors) {
        await this.$nextTick()
        const isClient = this.$store.getters['account/isClient']
        const isConsultant = this.$store.getters['account/isConsultant']
        if (isClient) {
          this.$router.push('/app/companies')
        } else if (isConsultant) {
          this.$router.push('/app/clients')
        } else {
          this.$router.push('/app/activities')
        }
      } else {
        this.password = ''
        this.$toasted.error(this.$t('errors.auth_error'))
      }
      this.loading = false
    },

    goAway () {
      window.location.href = 'https://profeed.systems/en/mix/'
    }
  }
}
</script>